import * as Yup from "yup";

const AddTabValidation = Yup.object().shape({
    attributename: Yup.string()
        .required('Please enter tab name')
});


export default AddTabValidation;
